<div class="space-y-6 pb-8">

    <!-- ====================================================== -->
    <!-- HEADER -->
    <!-- ====================================================== -->

    <section
        class="flex flex-col
               justify-between
               gap-5
               xl:flex-row
               xl:items-center"
    >

        <div>

            <!-- LIVE -->

            <div
                class="mb-2
                       flex items-center
                       gap-2
                       text-sm
                       font-semibold
                       text-emerald-600"
            >

                <span
                    class="relative flex h-2.5 w-2.5"
                >

                    <span
                        class="absolute
                               inline-flex
                               h-full w-full
                               animate-ping
                               rounded-full
                               bg-emerald-400
                               opacity-40"
                    ></span>

                    <span
                        class="relative
                               inline-flex
                               h-2.5 w-2.5
                               rounded-full
                               bg-emerald-500"
                    ></span>

                </span>

                Operación en tiempo real

            </div>


            <!-- GREETING -->

            <h2
                class="text-3xl
                       font-extrabold
                       tracking-[-0.03em]
                       text-[#1c1917]
                       sm:text-[34px]"
            >
                ¡Buen día, Ricardo! 👋
            </h2>


            <!-- CONTEXT -->

            <div
                class="mt-3
                       flex flex-wrap
                       items-center
                       gap-2"
            >

                <div
                    class="inline-flex
                           items-center
                           gap-2
                           rounded-full
                           border border-[#e9e4e0]
                           bg-white
                           px-3 py-1.5
                           text-xs
                           font-medium
                           text-[#57534e]
                           shadow-[0_1px_2px_rgba(28,25,23,0.03)]"
                >

                    <nz-icon
                        nzType="shop"
                        nzTheme="outline"
                        class="text-[#d95235]"
                    ></nz-icon>

                    {{ restaurantName() }}

                </div>


                <div
                    class="inline-flex
                           items-center
                           gap-2
                           rounded-full
                           border border-[#e9e4e0]
                           bg-white
                           px-3 py-1.5
                           text-xs
                           font-medium
                           text-[#57534e]
                           shadow-[0_1px_2px_rgba(28,25,23,0.03)]"
                >

                    <nz-icon
                        nzType="environment"
                        nzTheme="outline"
                        class="text-[#d95235]"
                    ></nz-icon>

                    {{ branchName() }}

                </div>

            </div>


            <p
                class="mt-2
                       text-sm
                       text-[#78716c]"
            >
                Aquí tienes un resumen de lo más importante
                en {{ restaurantName() }}.
            </p>

        </div>


        <!-- ACTIONS -->

        <div
            class="flex
                   items-center
                   gap-3"
        >

            <button
                nz-button
                class="!flex
                       !h-10
                       !items-center
                       !gap-2
                       !rounded-xl
                       !border-[#e7e2de]
                       !bg-white
                       !px-4
                       !text-[#57534e]
                       !shadow-none
                       hover:!border-[#d8cfc9]
                       hover:!text-[#1c1917]"
            >

                <nz-icon
                    nzType="calendar"
                    nzTheme="outline"
                ></nz-icon>

                Hoy

            </button>


            <button
                nz-button
                nzType="primary"
                class="!flex
                       !h-10
                       !items-center
                       !gap-2
                       !rounded-xl
                       !border-[#d95235]
                       !bg-[#d95235]
                       !px-4
                       !font-semibold
                       !text-white
                       !shadow-[0_8px_20px_rgba(217,82,53,0.18)]
                       hover:!border-[#be422c]
                       hover:!bg-[#be422c]"
            >

                <nz-icon
                    nzType="plus"
                    nzTheme="outline"
                ></nz-icon>

                Nuevo pedido

            </button>

        </div>

    </section>


    <!-- ====================================================== -->
    <!-- KPI CARDS -->
    <!-- ====================================================== -->

    <section
        class="grid
               grid-cols-1
               gap-4
               sm:grid-cols-2
               2xl:grid-cols-4"
    >

        @for (
            kpi of kpis;
            track kpi.title
        ) {

            <article
                class="group
                       relative
                       overflow-hidden
                       rounded-[20px]
                       border border-[#ebe7e3]
                       bg-white
                       p-5
                       shadow-[0_2px_10px_rgba(28,25,23,0.035)]
                       transition-all
                       duration-300
                       hover:-translate-y-0.5
                       hover:shadow-[0_14px_34px_rgba(28,25,23,0.07)]"
            >

                <!-- BRAND LINE -->

                <div
                    class="absolute
                           inset-x-0
                           top-0
                           h-[2px]
                           bg-gradient-to-r
                           from-[#d95235]
                           via-[#ff8a68]
                           to-transparent
                           opacity-0
                           transition
                           group-hover:opacity-100"
                ></div>


                <div
                    class="flex
                           items-start
                           justify-between"
                >

                    <div
                        class="flex h-11 w-11
                               items-center
                               justify-center
                               rounded-2xl
                               text-lg"
                        [class]="kpi.iconClass"
                    >

                        <nz-icon
                            [nzType]="kpi.icon"
                            nzTheme="outline"
                        ></nz-icon>

                    </div>


                    <span
                        class="rounded-full
                               bg-emerald-50
                               px-2.5 py-1
                               text-xs
                               font-semibold
                               text-emerald-600"
                    >
                        ↑ {{ kpi.trend }}
                    </span>

                </div>


                <div class="mt-5">

                    <div
                        class="text-sm
                               font-medium
                               text-[#78716c]"
                    >
                        {{ kpi.title }}
                    </div>


                    <div
                        class="mt-1
                               text-[29px]
                               font-extrabold
                               tracking-[-0.03em]
                               text-[#1c1917]"
                    >
                        {{ kpi.value }}
                    </div>


                    <div
                        class="mt-1
                               text-xs
                               text-[#a8a29e]"
                    >
                        {{ kpi.description }}
                    </div>

                </div>

            </article>

        }

    </section>


    <!-- ====================================================== -->
    <!-- ANALYTICS -->
    <!-- ====================================================== -->

    <section
        class="grid
               grid-cols-1
               gap-6
               2xl:grid-cols-[1.6fr_0.8fr_0.8fr]"
    >

        <!-- ================================================== -->
        <!-- SALES -->
        <!-- ================================================== -->

        <article
            class="relative
                   overflow-hidden
                   rounded-[22px]
                   border border-[#ebe7e3]
                   bg-white
                   p-6
                   shadow-[0_2px_10px_rgba(28,25,23,0.03)]"
        >

            <div
                class="absolute
                       left-0 top-0
                       h-[3px] w-16
                       rounded-br-full
                       bg-gradient-to-r
                       from-[#d95235]
                       to-[#ff8a68]"
            ></div>


            <div
                class="mb-7
                       flex
                       items-start
                       justify-between
                       gap-4"
            >

                <div>

                    <div
                        class="flex
                               items-center
                               gap-2.5"
                    >

                        <div
                            class="flex h-9 w-9
                                   items-center
                                   justify-center
                                   rounded-xl
                                   bg-[#fff0ea]
                                   text-[#d95235]"
                        >

                            <nz-icon
                                nzType="bar-chart"
                                nzTheme="outline"
                            ></nz-icon>

                        </div>


                        <h3
                            class="font-semibold
                                   text-[#292524]"
                        >
                            Ventas de la semana
                        </h3>

                    </div>


                    <div
                        class="mt-4
                               flex
                               items-baseline
                               gap-3"
                    >

                        <strong
                            class="text-3xl
                                   font-extrabold
                                   tracking-[-0.03em]
                                   text-[#1c1917]"
                        >
                            S/ 86,430
                        </strong>


                        <span
                            class="rounded-full
                                   bg-emerald-50
                                   px-2.5 py-1
                                   text-xs
                                   font-semibold
                                   text-emerald-600"
                        >
                            ↑ +18%
                        </span>

                    </div>


                    <p
                        class="mt-1
                               text-xs
                               text-[#a8a29e]"
                    >
                        Comparado con la semana anterior
                    </p>

                </div>


                <button
                    class="rounded-xl
                           border border-[#e8e3df]
                           bg-white
                           px-3 py-2
                           text-xs
                           font-medium
                           text-[#57534e]
                           transition
                           hover:bg-[#faf8f7]"
                >

                    Últimos 7 días

                    <nz-icon
                        nzType="down"
                        class="ml-2"
                    ></nz-icon>

                </button>

            </div>


            <!-- ============================================== -->
            <!-- BAR CHART -->
            <!-- ============================================== -->

            <div
                class="relative
                       flex h-[260px]
                       items-end
                       gap-3
                       border-b
                       border-[#ece8e5]
                       px-2"
            >

                @for (
                    day of sales;
                    track day.label
                ) {

                    <div
                        class="group
                               relative
                               flex h-full
                               flex-1
                               items-end
                               justify-center"
                    >

                        <!-- TOOLTIP -->

                        <div
                            class="absolute
                                   bottom-[calc(var(--height)+12px)]
                                   hidden
                                   whitespace-nowrap
                                   rounded-lg
                                   bg-[#29211e]
                                   px-2 py-1
                                   text-[10px]
                                   text-white
                                   shadow-lg
                                   group-hover:block"
                        >
                            {{ day.amount }}
                        </div>


                        <!-- BAR -->

                        <div
                            class="w-full
                                   max-w-[72px]
                                   rounded-t-xl
                                   bg-gradient-to-t
                                   from-[#d95235]
                                   to-[#ff9b7a]
                                   opacity-85
                                   shadow-[0_-6px_18px_rgba(217,82,53,0.08)]
                                   transition-all
                                   duration-300
                                   group-hover:opacity-100"
                            [style.height.%]="day.percent"
                        ></div>

                    </div>

                }

            </div>


            <div
                class="mt-3
                       grid grid-cols-7
                       text-center
                       text-[11px]
                       font-medium
                       text-[#a8a29e]"
            >

                @for (
                    day of sales;
                    track day.label
                ) {

                    <span>
                        {{ day.label }}
                    </span>

                }

            </div>

        </article>


        <!-- ================================================== -->
        <!-- ORDER STATUS -->
        <!-- ================================================== -->

        <article
            class="rounded-[22px]
                   border border-[#ebe7e3]
                   bg-white
                   p-6
                   shadow-[0_2px_10px_rgba(28,25,23,0.03)]"
        >

            <div
                class="mb-6
                       flex
                       items-center
                       justify-between"
            >

                <h3
                    class="font-semibold
                           text-[#292524]"
                >
                    Estados de pedidos
                </h3>


                <button
                    class="text-[#a8a29e]
                           transition
                           hover:text-[#57534e]"
                >

                    <nz-icon
                        nzType="more"
                        nzTheme="outline"
                    ></nz-icon>

                </button>

            </div>


            <!-- DONUT -->

            <div
                class="flex
                       justify-center
                       py-3"
            >

                <div
                    class="relative
                           flex h-40 w-40
                           items-center
                           justify-center
                           rounded-full
                           shadow-[inset_0_0_0_1px_rgba(28,25,23,0.03)]"
                    style="
                        background:
                        conic-gradient(
                            #16a673 0 33%,
                            #5487e8 33% 62%,
                            #e99a2e 62% 90%,
                            #df4b45 90% 100%
                        );
                    "
                >

                    <div
                        class="flex
                               h-[105px] w-[105px]
                               flex-col
                               items-center
                               justify-center
                               rounded-full
                               bg-white
                               shadow-[0_2px_12px_rgba(28,25,23,0.04)]"
                    >

                        <span
                            class="text-xs
                                   text-[#a8a29e]"
                        >
                            Total
                        </span>


                        <strong
                            class="text-3xl
                                   font-extrabold
                                   text-[#1c1917]"
                        >
                            42
                        </strong>

                    </div>

                </div>

            </div>


            <!-- LEGEND -->

            <div
                class="mt-5
                       space-y-3"
            >

                <div
                    class="flex
                           items-center
                           gap-3"
                >

                    <span
                        class="h-2.5 w-2.5
                               rounded-full
                               bg-[#16a673]"
                    ></span>

                    <span
                        class="text-sm
                               text-[#57534e]"
                    >
                        Listos
                    </span>

                    <strong
                        class="ml-auto
                               text-sm
                               text-[#292524]"
                    >
                        14
                    </strong>

                </div>


                <div
                    class="flex
                           items-center
                           gap-3"
                >

                    <span
                        class="h-2.5 w-2.5
                               rounded-full
                               bg-[#5487e8]"
                    ></span>

                    <span
                        class="text-sm
                               text-[#57534e]"
                    >
                        Entregados
                    </span>

                    <strong
                        class="ml-auto
                               text-sm
                               text-[#292524]"
                    >
                        12
                    </strong>

                </div>


                <div
                    class="flex
                           items-center
                           gap-3"
                >

                    <span
                        class="h-2.5 w-2.5
                               rounded-full
                               bg-[#e99a2e]"
                    ></span>

                    <span
                        class="text-sm
                               text-[#57534e]"
                    >
                        En cocina
                    </span>

                    <strong
                        class="ml-auto
                               text-sm
                               text-[#292524]"
                    >
                        12
                    </strong>

                </div>


                <div
                    class="flex
                           items-center
                           gap-3"
                >

                    <span
                        class="h-2.5 w-2.5
                               rounded-full
                               bg-[#df4b45]"
                    ></span>

                    <span
                        class="text-sm
                               text-[#57534e]"
                    >
                        Cancelados
                    </span>

                    <strong
                        class="ml-auto
                               text-sm
                               text-[#292524]"
                    >
                        4
                    </strong>

                </div>

            </div>

        </article>


        <!-- ================================================== -->
        <!-- KITCHEN -->
        <!-- ================================================== -->

        <article
            class="relative
                   overflow-hidden
                   rounded-[22px]
                   border border-[#ebe7e3]
                   bg-white
                   p-6
                   shadow-[0_2px_10px_rgba(28,25,23,0.03)]"
        >

            <div
                class="absolute
                       left-0 top-0
                       h-[3px] w-14
                       rounded-br-full
                       bg-[#e97845]"
            ></div>


            <div
                class="mb-5
                       flex
                       items-center
                       justify-between"
            >

                <div
                    class="flex
                           items-center
                           gap-2.5"
                >

                    <div
                        class="flex h-9 w-9
                               items-center
                               justify-center
                               rounded-xl
                               bg-[#fff2e8]
                               text-[#e97845]"
                    >

                        <nz-icon
                            nzType="fire"
                            nzTheme="outline"
                        ></nz-icon>

                    </div>


                    <h3
                        class="font-semibold
                               text-[#292524]"
                    >
                        Cola de cocina
                    </h3>

                </div>


                <button
                    class="text-xs
                           font-semibold
                           text-[#d95235]
                           transition
                           hover:text-[#b83f2b]"
                >
                    Ver cocina
                    <span class="ml-1">→</span>
                </button>

            </div>


            <div
                class="divide-y
                       divide-[#f0ece9]"
            >

                @for (
                    order of kitchenOrders;
                    track order.id
                ) {

                    <div
                        class="py-4
                               first:pt-0"
                    >

                        <div
                            class="flex
                                   items-center
                                   gap-3"
                        >

                            <strong
                                class="text-xs
                                       text-[#57534e]"
                            >
                                {{ order.id }}
                            </strong>


                            @if (
                                order.minutes <= 4
                            ) {

                                <span
                                    class="rounded-md
                                           bg-[#fff0ea]
                                           px-2 py-0.5
                                           text-[10px]
                                           font-semibold
                                           text-[#d95235]"
                                >
                                    {{ order.minutes }} min
                                </span>

                            }

                            @else {

                                <span
                                    class="rounded-md
                                           bg-red-50
                                           px-2 py-0.5
                                           text-[10px]
                                           font-semibold
                                           text-red-500"
                                >
                                    {{ order.minutes }} min
                                </span>

                            }


                            <span
                                class="ml-auto
                                       h-2 w-2
                                       rounded-full
                                       bg-[#e99a2e]"
                            ></span>

                        </div>


                        <div
                            class="mt-2
                                   text-sm
                                   font-semibold
                                   text-[#292524]"
                        >
                            {{ order.product }}
                        </div>


                        <div
                            class="mt-1
                                   text-[11px]
                                   text-[#a8a29e]"
                        >
                            {{ order.table }}
                            ·
                            {{ order.status }}
                        </div>

                    </div>

                }

            </div>

        </article>

    </section>


    <!-- ====================================================== -->
    <!-- ORDERS + OCCUPANCY -->
    <!-- ====================================================== -->

    <section
        class="grid
               grid-cols-1
               gap-6
               2xl:grid-cols-[1.6fr_0.8fr]"
    >

        <!-- ================================================== -->
        <!-- RECENT ORDERS -->
        <!-- ================================================== -->

        <article
            class="overflow-hidden
                   rounded-[22px]
                   border border-[#ebe7e3]
                   bg-white
                   shadow-[0_2px_10px_rgba(28,25,23,0.03)]"
        >

            <div
                class="flex
                       items-center
                       justify-between
                       px-6 py-5"
            >

                <div>

                    <h3
                        class="font-semibold
                               text-[#292524]"
                    >
                        Pedidos recientes
                    </h3>


                    <p
                        class="mt-1
                               text-xs
                               text-[#a8a29e]"
                    >
                        Últimos movimientos del restaurante
                    </p>

                </div>


                <button
                    class="text-xs
                           font-semibold
                           text-[#d95235]
                           transition
                           hover:text-[#b83f2b]"
                >
                    Ver todos
                    <span class="ml-1">→</span>
                </button>

            </div>


            <nz-table
                #ordersTable
                [nzData]="recentOrders"
                [nzShowPagination]="false"
                [nzFrontPagination]="false"
                nzSize="middle"
            >

                <thead>

                    <tr>

                        <th>Pedido</th>

                        <th>Mesa</th>

                        <th>Cliente</th>

                        <th>Total</th>

                        <th>Estado</th>

                        <th>Hace</th>

                    </tr>

                </thead>


                <tbody>

                    @for (
                        order of ordersTable.data;
                        track order.id
                    ) {

                        <tr>

                            <td>

                                <strong
                                    class="text-[#292524]"
                                >
                                    {{ order.id }}
                                </strong>

                            </td>


                            <td>
                                {{ order.table }}
                            </td>


                            <td>
                                {{ order.customer }}
                            </td>


                            <td>

                                <strong
                                    class="text-[#292524]"
                                >
                                    {{ order.total }}
                                </strong>

                            </td>


                            <td>

                                @switch (order.status) {

                                    @case ('En cocina') {

                                        <span
                                            class="inline-flex
                                                   rounded-md
                                                   border border-[#f5c67a]
                                                   bg-[#fff7e8]
                                                   px-2 py-1
                                                   text-[11px]
                                                   font-medium
                                                   text-[#b86b12]"
                                        >
                                            En cocina
                                        </span>

                                    }


                                    @case ('Listo') {

                                        <span
                                            class="inline-flex
                                                   rounded-md
                                                   border border-emerald-200
                                                   bg-emerald-50
                                                   px-2 py-1
                                                   text-[11px]
                                                   font-medium
                                                   text-emerald-700"
                                        >
                                            Listo
                                        </span>

                                    }


                                    @case ('Entregado') {

                                        <span
                                            class="inline-flex
                                                   rounded-md
                                                   border border-blue-200
                                                   bg-blue-50
                                                   px-2 py-1
                                                   text-[11px]
                                                   font-medium
                                                   text-blue-600"
                                        >
                                            Entregado
                                        </span>

                                    }


                                    @case ('Cancelado') {

                                        <span
                                            class="inline-flex
                                                   rounded-md
                                                   border border-red-200
                                                   bg-red-50
                                                   px-2 py-1
                                                   text-[11px]
                                                   font-medium
                                                   text-red-600"
                                        >
                                            Cancelado
                                        </span>

                                    }

                                }

                            </td>


                            <td
                                class="text-[#a8a29e]"
                            >
                                {{ order.elapsed }}
                            </td>

                        </tr>

                    }

                </tbody>

            </nz-table>

        </article>


        <!-- ================================================== -->
        <!-- OCCUPANCY -->
        <!-- ================================================== -->

        <article
            class="relative
                   overflow-hidden
                   rounded-[22px]
                   border border-[#35251f]
                   bg-[#211713]
                   p-6
                   text-white
                   shadow-[0_16px_42px_rgba(39,22,16,0.17)]"
        >

            <!-- BACKGROUND PHOTO -->

            <img
                src="/images/login-restaurant-bg.png"
                alt=""
                class="absolute inset-0
                       h-full w-full
                       object-cover
                       object-[80%_center]
                       opacity-25"
            />


            <!-- OVERLAY -->

            <div
                class="absolute inset-0
                       bg-gradient-to-r
                       from-[#1b120f]/98
                       via-[#241713]/92
                       to-[#301a13]/76"
            ></div>


            <!-- CONTENT -->

            <div class="relative z-10">

                <div
                    class="flex
                           items-center
                           justify-between"
                >

                    <div>

                        <div
                            class="text-xs
                                   font-semibold
                                   uppercase
                                   tracking-[0.16em]
                                   text-[#bfa89f]"
                        >
                            Salón principal
                        </div>


                        <h3
                            class="mt-2
                                   text-xl
                                   font-semibold"
                        >
                            Ocupación de mesas
                        </h3>

                    </div>


                    <div
                        class="flex h-11 w-11
                               items-center
                               justify-center
                               rounded-xl
                               bg-[#d95235]/15
                               text-[#ff8a68]"
                    >

                        <nz-icon
                            nzType="appstore"
                            nzTheme="outline"
                        ></nz-icon>

                    </div>

                </div>


                <div class="mt-8">

                    <div
                        class="flex
                               items-end
                               justify-between"
                    >

                        <div>

                            <span
                                class="text-5xl
                                       font-extrabold
                                       tracking-[-0.04em]"
                            >
                                67
                            </span>

                            <span
                                class="ml-1
                                       text-xl
                                       text-white/45"
                            >
                                %
                            </span>

                        </div>


                        <div
                            class="text-right
                                   text-xs
                                   text-white/55"
                        >
                            12 de 18 mesas
                        </div>

                    </div>


                    <nz-progress
                        [nzPercent]="67"
                        [nzShowInfo]="false"
                        nzStrokeColor="#e85d3f"
                        class="mt-5"
                    ></nz-progress>

                </div>


                <div
                    class="mt-8
                           grid grid-cols-2
                           gap-3"
                >

                    <div
                        class="rounded-xl
                               border border-white/[0.07]
                               bg-white/[0.055]
                               p-4
                               backdrop-blur-sm"
                    >

                        <div
                            class="text-xs
                                   text-white/45"
                        >
                            Disponibles
                        </div>


                        <strong
                            class="mt-1
                                   block
                                   text-2xl
                                   text-emerald-400"
                        >
                            6
                        </strong>

                    </div>


                    <div
                        class="rounded-xl
                               border border-white/[0.07]
                               bg-white/[0.055]
                               p-4
                               backdrop-blur-sm"
                    >

                        <div
                            class="text-xs
                                   text-white/45"
                        >
                            Ocupadas
                        </div>


                        <strong
                            class="mt-1
                                   block
                                   text-2xl
                                   text-[#ff8664]"
                        >
                            12
                        </strong>

                    </div>

                </div>

            </div>

        </article>

    </section>

</div>